import { render, staticRenderFns } from "./BranchTree.vue?vue&type=template&id=2cc2d7b0&scoped=true"
import script from "./BranchTree.vue?vue&type=script&lang=js"
export * from "./BranchTree.vue?vue&type=script&lang=js"
import style0 from "./BranchTree.vue?vue&type=style&index=0&id=2cc2d7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc2d7b0",
  null
  
)

export default component.exports